import { CartItem } from "@framework/types";
import { addItemWithQuantity, calculateUniqueItems, calculateItemTotals, calculateTotalItems, calculateTotal } from "./cart.utils";
type Action = {
  type: "ADD_ITEM_WITH_QUANTITY";
  item: CartItem;
  quantity: number;
} | {
  type: "REMOVE_ITEM";
  productCode: string;
} | {
  type: "UPDATE_ITEM_QUANTITY";
  productCode: string;
  quantity: number;
} | {
  type: "RESET_CART";
} | {
  type: "SET_CART";
  payload: Partial<State>;
};
export interface State {
  items: CartItem[];
  isEmpty: boolean;
  totalItems: number;
  totalUniqueItems: number;
  total: number;
}
export const initialState: State = {
  items: [],
  isEmpty: true,
  totalItems: 0,
  totalUniqueItems: 0,
  total: 0
};
export function cartReducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_CART":
      {
        const transformedItems = action.payload.items?.map(item => ({
          ...item,
          id: Number(item.id)
        })) || state.items;
        return {
          ...state,
          items: transformedItems,
          totalItems: calculateTotalItems(transformedItems),
          total: action.payload.total ?? state.total,
          isEmpty: transformedItems.length === 0
        };
      }
    case "ADD_ITEM_WITH_QUANTITY":
      {
        const items = addItemWithQuantity(state.items, action.item, action.quantity);
        return generateFinalState(state, items);
      }
    case "REMOVE_ITEM":
      {
        const items = state.items.filter(item => item.productCode !== action.productCode);
        return generateFinalState(state, items);
      }
    case "UPDATE_ITEM_QUANTITY":
      {
        const items = state.items.map(item => item.productCode === action.productCode ? {
          ...item,
          quantity: action.quantity
        } : item);
        return generateFinalState(state, items);
      }
    case "RESET_CART":
      {
        return {
          ...state,
          items: [],
          totalItems: 0,
          totalUniqueItems: 0,
          total: 0,
          isEmpty: true
        };
      }
    default:
      return state;
  }
}
const generateFinalState = (state: State, items: CartItem[]) => {
  const totalUniqueItems = calculateUniqueItems(items);
  const totalItems = calculateTotalItems(items);
  const total = calculateTotal(items);
  return {
    ...state,
    items: calculateItemTotals(items),
    totalItems,
    totalUniqueItems,
    total,
    isEmpty: totalUniqueItems === 0
  };
};